<template>
  <div id="app">
    <NavBar :links="navItems"></NavBar>
    <PianoHeader></PianoHeader>
    <TopSection></TopSection>
    <LessonsSection id="lessons"/>
    <Testimonials id="testimonials"/>
    <About id="about"/>
    <ContactCTA/>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import PianoHeader from "@/components/Header";
import TopSection from "@/components/TopSection";
import LessonsSection from "@/components/LessonsSection";
import Testimonials from "@/components/Testimonials";
import About from "@/components/About";
import ContactCTA from "@/components/ContactCTA";

export default {
  name: 'App',
  components: {
    ContactCTA,
    About,
    Testimonials,
    LessonsSection,
    TopSection,
    PianoHeader,
    NavBar
  },
  data: () => {
    return {
      navItems: [
        {
          text: "Home",
          href: "#navbar"
        },
        {
          text: "Lessons",
          href: "#lessons"
        },
        {
          text: "Testimonials",
          href: "#testimonials"
        },
        {
          text: "About",
          href: "#about"
        },
      ]
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
  max-width: 1200px;
  margin: 0px auto 0;
}

p {
  font-size: 28px;
  text-align: left;
}

h2 {
  text-transform: uppercase;
  font-size: 60px;
  text-align: left;
}

.right {
  text-align: right;
}

.mobile-hide {
  display: inherit;
}

.mobile-show {
  display: none;
}

@media only screen
and (max-device-width: 667px)
and (orientation: portrait) {
  .mobile-hide {
    display: none;
  }

  .mobile-show {
    display: inherit;
  }

  img.hand-drawn {
    margin: auto;
    padding-left: 4.5%;
    width: 60%;
  }

  #app {
    margin: 0 10%;
  }

  h2 {
    font-size: 48px;
  }

  p {
  }
}
</style>
